// src/admin/AdminContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(true);

  // Rehydrate from localStorage (for new tabs/windows)
  useEffect(() => {
    try {
      const fetchUser = async () => {
      const storedFlag = await localStorage.getItem("admin_isAdmin");
      const storedKey = await localStorage.getItem("admin_apiKey");
      if (storedFlag === "true" && storedKey) {
        setIsAdmin(true);
        setApiKey(storedKey);
      }
      setLoading(false);
      console.log("[ADMIN] Rehydrated admin state from localStorage");
    };
    fetchUser()
    } catch (e) {
      console.warn("[ADMIN] Failed to rehydrate admin state", e);
    }
  }, []);

  const login = (key) => {
    const trimmed = (key || "").trim();
    if (!trimmed) return false;

    console.log("[ADMIN] login() called with key (masked).");
    setApiKey(trimmed);
    setIsAdmin(true);

    try {
      localStorage.setItem("admin_isAdmin", "true");
      localStorage.setItem("admin_apiKey", trimmed);
    } catch (e) {
      console.warn("[ADMIN] Failed to persist admin state", e);
    }

    return true;
  };

  const logout = () => {
    console.log("[ADMIN] logout()");
    setIsAdmin(false);
    setApiKey("");
    try {
      localStorage.removeItem("admin_isAdmin");
      localStorage.removeItem("admin_apiKey");
    } catch (e) {
      console.warn("[ADMIN] Failed to clear admin state", e);
    }
  };

  return (
    <AdminContext.Provider value={{ isAdmin, apiKey, loading, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
